export default __webpack_public_path__ + "static/media/04.c795a5c1.svg";